import script from "./WizardNotifications.vue?vue&type=script&setup=true&lang=js"
export * from "./WizardNotifications.vue?vue&type=script&setup=true&lang=js"

import "./WizardNotifications.vue?vue&type=style&index=0&id=8452151c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8452151c"]])

export default __exports__